// extracted by mini-css-extract-plugin
export default {"row":"IgnoreTime_row__gaWYw","shift":"IgnoreTime_shift__0FF2w","placeHolderShimmer":"IgnoreTime_placeHolderShimmer__ky8p3"};